export default __webpack_public_path__ + "static/media/DinosaurSafari_10.cea1fd24.png";